import React from "react";
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
  Checkbox,
} from "antd";
import Footer from "./ViewModal/Footer";
import Productos from "./ViewModal/Productos";
import Referencias from "./ViewModal/Referencias";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {

    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };


  render() {
    return (
      <Modal
        title={`Ver Honorario`}
        visible={this.props.visible}
        onCancel={this.props.onClose}
        footer={[
          <Button
            key="1"
            onClick={this.props.onClose}
          >
            Cancelar
          </Button>
        ]}
        style={{ top: 30 }}
        width="1100px"
      >
        <Form>
          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "100%" }}
                    value={this.props.formValues.fechaStr}
                    suffix={
                      <Icon
                        type="calendar"
                        style={{ color: "rgba(0,0,0,.25)" }}
                      />
                    }
                  />
              
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Recepción">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "100%" }}
                    value={this.props.formValues.fechaRecepcionStr}
                  />
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Moneda">
                <Input readOnly value={this.props.formValues.nombreMoneda} />
              </Form.Item>
            </div>


          </div>
          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Nro Documento">
                <Input readOnly value={this.props.formValues.numeroDocumentoEntidad} />
              </Form.Item>
            </div>

            <div className="col-md-8 form-group">
              <Form.Item label="Entidad">
                <Input readOnly value={this.props.formValues.nombreEntidad} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 form-group">
              <Form.Item label="Dirección">
                <Input readOnly value={this.props.formValues.direcionEntidad} />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Input
                    readOnly
                    style={{ width: "40%" }}
                    value={this.props.formValues.serie}
                  />
                  <Input
                    readOnly
                    style={{ width: "60%" }}
                    value={this.props.formValues.documento}
                  />
                </InputGroup>
              </Form.Item>
            </div>


          </div>

          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Establecimiento">
                <Input
                  readOnly
                  value={this.props.formValues.nombreEstablecimiento}
                />
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Proyecto">
                <Input readOnly value={this.props.formValues.proyecto} />
              </Form.Item>
            </div>



          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Observación">
                <Input readOnly value={this.props.formValues.observacion} />
              </Form.Item>
            </div>


          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs>
                <TabPane tab="Detalle de Productos y Servicios" key="1">
                  <Productos dataSource={this.props.formValues.detalles} />
                </TabPane>
                <TabPane tab="Detalle de Referencias" key="2">
                  <Referencias dataSource={this.props.formValues.referencias} />
                </TabPane>

              </Tabs>
            </div>
          </div>
          <Footer formValues={this.props.formValues} />
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(FormModal);
